// POS
// bits 17-21

const BASEFORM_POS_ADJECTIVE = 0x10000
const BASEFORM_POS_ADVERB = 0x20000
const BASEFORM_POS_CONJUNCTION = 0x30000
const BASEFORM_POS_NOUN = 0x60000
const BASEFORM_POS_PREPOSITION = 0x80000
const BASEFORM_POS_VERB = 0xd0000
const BASEFORM_POS_PRONOUN = 0x90000
// Gender
//bits 22-23
// const BASEFORM_GENDER = 0x600000
const BASEFORM_GENDER_MASCULINE = 0x200000
const BASEFORM_GENDER_FEMININE =	0x400000
const BASEFORM_GENDER_MASCULINEFEMININE = 0x600000
// Number
// bits 25-27
// const BASEFORM_NUMBER =	0x7000000
const BASEFORM_NUMBER_SINGULAR = 0x1000000
const BASEFORM_NUMBER_PLURAL =	0x2000000
const BASEFORM_NUMBER_DUAL =	0x3000000
const BASEFORM_NUMBER_DUALPLURAL =	0x4000000
const BASEFORM_NUMBER_SINGULARPLURAL =	0x5000000
// Person
// bits 28-30
// const BASEFORM_PERSON =	0x38000000
const BASEFORM_PERSON_1 = 0x8000000
const BASEFORM_PERSON_2 = 0x10000000
const BASEFORM_PERSON_3 = 0x18000000
const BASEFORM_PERSON_ANY = 0x20000000
// Status
// bits 31-32
// const BASEFORM_STATUS = 0xc0000000
const BASEFORM_STATUS_ABSOLUTE = 0x40000000
const BASEFORM_STATUS_CONSTRUCT = 0x80000000
const BASEFORM_STATUS_ABSOLUTECONSTRUCT = 0xc0000000
// Tense
// bits 34-36
const BASEFORM_TENSE_PAST = 0x200000000
//const BASEFORM_TENSE_ALLTIME = 0x400000000
const BASEFORM_TENSE_PRESENT = 0x600000000
const BASEFORM_TENSE_FUTURE = 0x800000000
const BASEFORM_TENSE_IMPERATIVE = 0xa00000000
//BASEFORM_TENSE_TOINFINITIVE = Long.fromString('c00000000', false, 16)
const BASEFORM_TENSE_TOINFINITIVE = 0xc00000000
//const BASEFORM_TENSE_BAREINFINITIVE = 0xe00000000
// Function
// bits 37-38
// const SUFFIX_FUNCTION = 0x3000000000
const SUFFIX_FUNCTION_POSSESIVEPRONOUN = 0x1000000000
const SUFFIX_FUNCTION_ACCUSATIVENOMINATIVE = 0x2000000000
const SUFFIX_FUNCTION_PRONOMIAL = 0x3000000000
// const SUFFIX_MASK = SUFFIX_FUNCTION
//////////////////////

//////////////////////
// const SUFFIX_GENDER = 0x18000000000
const SUFFIX_GENDER_MASCULINE = 0x8000000000
const SUFFIX_GENDER_FEMININE = 0x10000000000
const SUFFIX_GENDER_MASCULINEFEMININE = 0x18000000000
// const SUFFIX_NUMBER = 0x1c0000000000
const SUFFIX_NUMBER_SINGULAR = 0x40000000000
const SUFFIX_NUMBER_PLURAL = 0x80000000000
// const SUFFIX_PERSON = 0xe00000000000
const SUFFIX_PERSON_1 = 0x200000000000
const SUFFIX_PERSON_2 = 0x400000000000
const SUFFIX_PERSON_3 = 0x600000000000
const SUFFIX_PERSON_ANY = 0x800000000000

// Lists of the bitmasks
export const SUFFIX_FUNCTION_LIST = [0, SUFFIX_FUNCTION_POSSESIVEPRONOUN, SUFFIX_FUNCTION_ACCUSATIVENOMINATIVE, SUFFIX_FUNCTION_PRONOMIAL]
//const BASEFORM_POS_LIST = [BASEFORM_POS_CONTINUE, BASEFORM_POS_ADJECTIVE, BASEFORM_POS_ADVERB, BASEFORM_POS_CONJUNCTION, BASEFORM_POS_AT_PREP, BASEFORM_POS_NEGATION, BASEFORM_POS_NOUN, BASEFORM_POS_NUMERAL, BASEFORM_POS_PREPOSITION, BASEFORM_POS_PRONOUN, BASEFORM_POS_PROPERNAME, BASEFORM_POS_CITATION, BASEFORM_POS_INITIALISM, BASEFORM_POS_VERB, BASEFORM_POS_PUNCTUATION, BASEFORM_POS_INTERROGATIVE, BASEFORM_POS_INTERJECTION, BASEFORM_POS_UNKNOWN, BASEFORM_POS_QUANTIFIER, BASEFORM_POS_EXISTENTIAL, BASEFORM_POS_MODAL, BASEFORM_POS_PREFIX, BASEFORM_POS_URL, BASEFORM_POS_FOREIGN, BASEFORM_POS_JUNK, BASEFORM_POS_PARTICIPLE, BASEFORM_POS_COPULA, BASEFORM_POS_REF, BASEFORM_POS_TITULAR, BASEFORM_POS_SHEL_PREP, BASEFORM_POS_UNCLEAR, BASEFORM_POS_NONSTANDARD]
export const BASEFORM_POS_LIST = [ 0, BASEFORM_POS_NOUN, BASEFORM_POS_ADJECTIVE, BASEFORM_POS_VERB, BASEFORM_POS_ADVERB, BASEFORM_POS_PREPOSITION, BASEFORM_POS_CONJUNCTION, BASEFORM_POS_PRONOUN]
export const BASEFORM_GENDER_LIST = [0, BASEFORM_GENDER_MASCULINE, BASEFORM_GENDER_FEMININE, BASEFORM_GENDER_MASCULINEFEMININE]
export const BASEFORM_NUMBER_LIST = [0, BASEFORM_NUMBER_SINGULAR, BASEFORM_NUMBER_PLURAL, BASEFORM_NUMBER_DUAL, BASEFORM_NUMBER_DUALPLURAL, BASEFORM_NUMBER_SINGULARPLURAL]
export const BASEFORM_PERSON_LIST = [0, BASEFORM_PERSON_1, BASEFORM_PERSON_2, BASEFORM_PERSON_3, BASEFORM_PERSON_ANY]
export const BASEFORM_STATUS_LIST = [0, BASEFORM_STATUS_ABSOLUTE, BASEFORM_STATUS_CONSTRUCT, BASEFORM_STATUS_ABSOLUTECONSTRUCT]
export const BASEFORM_TENSE_LIST = [0, BASEFORM_TENSE_PAST, BASEFORM_TENSE_PRESENT, BASEFORM_TENSE_FUTURE, BASEFORM_TENSE_IMPERATIVE, BASEFORM_TENSE_TOINFINITIVE]
//export const BASEFORM_BINYAN_LIST = [0, BASEFORM_BINYAN_PAAL, BASEFORM_BINYAN_NIFAL, BASEFORM_BINYAN_HIFIL, BASEFORM_BINYAN_HUFAL, BASEFORM_BINYAN_PIEL, BASEFORM_BINYAN_PUAL, BASEFORM_BINYAN_HITPAEL]


// Dovid additions
//const PREFIX_FUNCTION_LIST = [PREFIX_FUNCTION_CONJUNCTION,PREFIX_FUNCTION_DEFINITEARTICLE,PREFIX_FUNCTION_INTERROGATIVE,PREFIX_FUNCTION_PREPOSITION,PREFIX_FUNCTION_RELATIVIZER_SUBORDINATINGCONJUNCTION,PREFIX_FUNCTION_TEMPORALSUBCONJ,PREFIX_FUNCTION_ADVERB]

export const SUFFIX_GENDER_LIST = [0, SUFFIX_GENDER_MASCULINE,SUFFIX_GENDER_FEMININE,SUFFIX_GENDER_MASCULINEFEMININE]
export const SUFFIX_NUMBER_LIST = [0, SUFFIX_NUMBER_SINGULAR, SUFFIX_NUMBER_PLURAL]
export const SUFFIX_PERSON_LIST = [0, SUFFIX_PERSON_1, SUFFIX_PERSON_2, SUFFIX_PERSON_3, SUFFIX_PERSON_ANY]

export const NIKUD = {
    HATAF_SEGOL: 'ֱ',   HATAF_PATAH: 'ֲ',   HATAF_QAMATZ: 'ֳ',    HIRIQ: 'ִ',     TSERE: 'ֵ',   SEGOL: 'ֶ',
    PATAH: 'ַ',  QAMATZ: 'ָ',  HOLAM: 'ֹ',   QUBUTZ: 'ֻ',   SHEVA: 'ְ',     QAMATZ_QATAN: 'ׇ', DAGESH: 'ּ'
}
